import { render, staticRenderFns } from "./edit-profile.component.html?vue&type=template&id=ca0beed2&scoped=true&external"
import script from "./edit-profile.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-profile.component.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-profile.component.scss?vue&type=style&index=0&id=ca0beed2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0beed2",
  null
  
)

export default component.exports